import { jsxs, jsx } from "react/jsx-runtime";
import { useState, useCallback } from "react";
import { PropTypes } from "prop-types";
import { useTheme } from "styled-components";
import { AnimatePresence, MotionConfig, motion } from "framer-motion";
import { easeQuadOut } from "d3-ease";
import { useId } from "@reach/auto-id";
import "lodash/fp";
import "../../contexts/display-mode-context/display-mode-context.es.js";
import "../../contexts/global-edit-context/global-edit-context.es.js";
import "../../contexts/toast-context/toast-context.es.js";
import "../../utils/is-valid-ref.es.js";
import "../../hooks/use-horizontal-scroll.es.js";
import "react-use-measure";
import "@juggle/resize-observer";
import "@reach/utils";
import "@reach/rect";
import "compute-scroll-into-view";
import { Icon } from "../icon/icon.es.js";
import { Inline } from "../inline/inline.es.js";
import { InlineItem } from "../inline/inline-item.es.js";
import { AccordionItemWrapper, AccordionItemButton, AccordionItemContent, AccordionItemContentInner } from "./accordion-item.styles.es.js";
const propTypes = {
  children: PropTypes.node.isRequired,
  defaultExpanded: PropTypes.bool,
  title: PropTypes.string.isRequired
};
const defaultProps = {
  defaultExpanded: false
};
const AccordionItem = ({ children, defaultExpanded, title }) => {
  const theme = useTheme();
  const id = useId();
  const [expanded, setExpanded] = useState(defaultExpanded);
  const handleToggle = useCallback(() => {
    setExpanded((exp) => !exp);
  }, []);
  return /* @__PURE__ */ jsxs(AccordionItemWrapper, { children: [
    /* @__PURE__ */ jsx(
      AccordionItemButton,
      {
        "aria-controls": `bungle-collapsible-content-${id}`,
        "aria-expanded": expanded,
        onClick: handleToggle,
        children: /* @__PURE__ */ jsxs(Inline, { as: "span", space: "xsmall", children: [
          /* @__PURE__ */ jsx(InlineItem, { children: /* @__PURE__ */ jsx(
            Icon,
            {
              color: theme.color.gray6,
              magnitude: "xsmall",
              transform: expanded ? "rotate(90deg)" : void 0,
              transitionDuration: 300,
              type: "right"
            }
          ) }),
          /* @__PURE__ */ jsx(InlineItem, { children: title })
        ] })
      }
    ),
    /* @__PURE__ */ jsx(AccordionItemContent, { id: `bungle-collapsible-content-${id}`, children: /* @__PURE__ */ jsx(AnimatePresence, { initial: false, children: expanded && /* @__PURE__ */ jsx(MotionConfig, { transition: { ease: easeQuadOut, duration: 0.1 }, children: /* @__PURE__ */ jsx(
      motion.div,
      {
        "aria-hidden": !expanded,
        style: { overflow: "hidden" },
        initial: { height: 0 },
        animate: { height: "auto" },
        exit: { height: 0 },
        children: /* @__PURE__ */ jsx(AccordionItemContentInner, { children })
      }
    ) }) }) })
  ] });
};
AccordionItem.propTypes = propTypes;
AccordionItem.defaultProps = defaultProps;
export {
  AccordionItem
};
